export default "__VITE_ASSET__eb8046d3__"